<template>
  <!-- div class="grid">
    <div class="col-1">
      <div class="label-number">&nbsp;</div>
    </div>
    <div class="col-11">
      <div class="grid">
        <div class="col-12">
          <div class="paragraph title-margin" v-html="$tc('questionnaireForm.titleOrganizationalCulture')"/>
        </div>
      </div>
    </div>
  </div -->

  <div class="m-0 h-full" style="justify-content: space-between">
    <div class="flex w-full h-full" style="position: relative">

      <div class="questionCount">
        <span>Question</span>
        <div style='font-weight: 700;'>
          <span id='currentQuestion'>{{ activeQuestion - 97 }}</span>
          <span style='font-weight: 400;'>/</span>
          <span id='allQuestions'>12</span>
        </div>
      </div>

      <Stepper linear unstyled: true v-model:active-step="activeSub">

        <StepperPanel :header="$tc('questionnaireForm.titleLeadershipByCoaching')">
          <QuestionRating v-if="activeQuestion == 98" question="98" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 99" question="99" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 100" question="100" :change="autoSave"></QuestionRating>
        </StepperPanel>

        <StepperPanel :header="$tc('questionnaireForm.titleFosteringACultureOfKnowledgeSharingAndLearning')">
          <QuestionRating v-if="activeQuestion == 101" question="101" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 102" question="102" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 103" question="103" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 104" question="104" :change="autoSave"></QuestionRating>
        </StepperPanel>

        <StepperPanel :header="$tc('questionnaireForm.titleInteractionsAmongEmployees')">
          <QuestionRating v-if="activeQuestion == 105" question="105" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 106" question="106" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 107" question="107" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 108" question="108" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 109" question="109" :change="autoSave"></QuestionRating>
        </StepperPanel>

      </Stepper>

    </div>
  </div>

</template>


<script lang="ts">
// @ is an alias to /src

import { Options, Vue } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import axios from 'axios';
import { User } from "@/data/User";
import { Application } from "@/data/Application";
import { AuthService } from "@/service/AuthService";
import { ref } from "vue";

import { defineComponent, PropType } from 'vue';
import QuestionRating from "@/components/questionnaire/QuestionRating.vue";

export default defineComponent({
  components: { QuestionRating },
  computed: {
    User() {
      return User
    },
    Application() {
      return Application
    }
  },
  props: {
    activeQuestion: {
      type: Number,
      required: true
    },
    activeSub: {
      type: Number,
      required: true
    }
  },
  methods: {
    autoSave: () => {
      User.get().invitation.response.save();
    }
  },
  setup() {
  },
})
</script>
<style>
.title-margin {
  margin-left: -30px;
}

.p-stepper .p-stepper-header.p-highlight .p-stepper-number {
  background: #0d3d52;
  color: #ffffff;
}

.stepper-offset-horizontal {
  margin-left: 78px;
}

.p-stepper {
  width: 99% !important;
}

.p-stepper-content {
  margin-left: -75px;
}

.p-slider-range {
  background-color: #5EBCB8;
}

.p-slider .p-slider-handle {
  background-color: #0d3d52;
  border-style: none;
}
</style>
